import { createFileRoute } from "@tanstack/react-router";
import KortassistentSettings from "@/pages/admin/KortassistentSettings";

export const Route = createFileRoute("/admin/kortassistent")({
  component: KortassistentSettings,
});
